import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './theme/tokens.css';
import './theme/base.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
